import { View, ScrollView, useWindowDimensions, Animated as RNAnimated } from 'react-native';
import { Pressable } from 'react-native';
import styles from "@stylesheet";
import * as Animatable from 'react-native-animatable';
import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useLayoutEffect, useMemo, useRef, useState } from "react";
import toTitleCase from '@hooks/toTitleCase';
import { FontAwesome5, AntDesign } from '@expo/vector-icons';
import React, { memo } from 'react';
import AchievementBackground from "@assets/--native/AchievementBackground";
import { Title, Text } from '@constants/Themed';
import Measurable, { MeasurableHandle } from '@components/MeasurableView';
import { debounce, uniqueId } from 'lodash';
import { UserHierarchyContext } from '@hooks/userContext';
import { Gesture, PanGestureHandlerEventPayload } from 'react-native-gesture-handler';
import Animated, { interpolateColor, runOnJS, useSharedValue } from 'react-native-reanimated';
import { ZoomableViewEvent } from '@openspacelabs/react-native-zoomable-view';
import parseByDelimiter from '@utils/parseByDelimiter';
import ActionListComponent, { FlowListItem } from './FlowListComponent';
import { useDispatch, useSelector } from 'react-redux';
import { Popover, Separator, SizableText } from 'tamagui';
import flowList from '../utils/flowList';
import moment from 'moment';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import TagViewer from '@components/Global/TagViewer';

type FlowComponentProps = {
  zoomVars: ZoomableViewEvent;
  portrait: boolean;
  transform: { translateX: number, translateY: number };
  onSnap: (index: string) => void;
  reverse: boolean;
  schemaData: any;
  index: number;
  showArrows: boolean;
  positionHandler: (values: any) => void;
  _openAddUserModal?: () => void;
  accelerateValue: number;
  initialZoom: number
}

export interface FlowComponentHandle {
  setValues: (values: any) => void;
  setZoomProps: (props: ZoomableViewEvent) => void;
}

const initalZoomProps: ZoomableViewEvent = {
  offsetX: -500,
  offsetY: -500,
  zoomLevel: 0.4,
  originalHeight: 0,
  originalWidth: 0,
  originalPageX: 0,
  originalPageY: 0
}

interface Action {
  icon: string;
  title: string;
}

const ACTION_GAP = 70;

export const ActionArrow = ({
  startColor = '#5ac0ea',
  endColor = '#a9c0ff',
  zoomVars = {}
}) => {
  const popRef = useRef(null);
  const pulseAnim = useRef(new RNAnimated.Value(1)).current;
  const colorAnim = useRef(new RNAnimated.Value(0)).current;
  const theme = themeSelector();
  const [gradientColors, setGradientColors] = useState({
    start: startColor,
    mid: startColor,
    end: endColor,
  });


  const startPulsing = () => {
    RNAnimated.loop(
      RNAnimated.sequence([
        RNAnimated.timing(pulseAnim, {
          toValue: 1.005,
          duration: 500,
          useNativeDriver: true,
        }),
        RNAnimated.timing(pulseAnim, {
          toValue: 1,
          duration: 500,
          useNativeDriver: true,
        }),
      ])
    ).start();
  };

  const startColorAnimation = () => {
    RNAnimated.loop(
      RNAnimated.sequence([
        RNAnimated.timing(colorAnim, {
          toValue: 1,
          duration: 2000,
          useNativeDriver: false,
        }),
        RNAnimated.timing(colorAnim, {
          toValue: 0,
          duration: 2000,
          useNativeDriver: false,
        }),
      ])
    ).start();

    colorAnim.addListener(({ value }) => {
      setGradientColors({
        start: interpolateColor(value, [0, 1], [startColor, endColor]),
        mid: interpolateColor(value, [0, 1], [startColor, endColor]),
        end: interpolateColor(value, [0, 1], [endColor, startColor]),
      });
    });
  };

  useEffect(() => {
    startPulsing();
    startColorAnimation();
    return () => {
      colorAnim.removeAllListeners();
    };
  }, []);

  return (
    <View style={{ overflow: "visible" }}>
      <Popover
        ref={popRef}
        key={JSON.stringify(zoomVars)}
        // key={uniqueId()}
        stayInFrame
        allowFlip
        strategy="fixed"
        // strategy='fixed'
        size={"$4"}
      >
        <Popover.Trigger
          asChild
          // focusStyle={{
          //   borderColor: 'rgb(90,192,234)',
          //   borderWidth: 2,
          //   borderStyle: 'solid',
          // }}
          style={{
            position: 'absolute',
            zIndex: 1000,
            width: 40,
            height: 40,
            backgroundColor: 'transparent',
          }}
        >
          <Pressable
            // onPress={pressCallback}
            hitSlop={20}
            style={{ transform: [{ scale: 1.5 }], left: -25, top: -42, borderTopStartRadius: 0, borderBottomEndRadius: 20, borderBottomStartRadius: 20, height: 40, backgroundColor: "rgb(90,192,234)" }}
          >
            <AntDesign name="plus" color="rgb(255, 255, 255)" style={[styles.centerEverything, { minHeight: 40, top: 2, zIndex: 100, borderBottomStartRadius: 20, borderBottomEndRadius: 20, overflow: "hidden" }]} size={32} />
          </Pressable>
        </Popover.Trigger>
        <Popover.Content
          // asChild
          enterStyle={{ y: 50, opacity: 0 }}
          exitStyle={{ y: 10, opacity: 0 }}
          elevate
          borderColor="$borderColor"
          overflow='visible'
          style={{ shadowRadius: 20, minHeight: 350, shadowOpacity: .2, top: "10%", backgroundColor: theme ? "white" : "#f3f3f3" }}
          animation={[
            'superBouncy',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}>
          <Popover.Arrow borderWidth={10} borderColor="white" />
          <ScrollView style={{ borderRadius: 20, minHeight: 300, zIndex: 100, flex: 1 }}>
            {
              flowList.map((item, index) => {
                return (
                  <ActionListComponent open staticLink item={item} index={index} />
                )
              })
            }
          </ScrollView>
        </Popover.Content>
      </Popover>
    </View>
  )
}

const FlowComponent = forwardRef<FlowComponentHandle, FlowComponentProps>((props, ref) => {
  const { zoomVars, portrait, transform, onSnap, reverse, schemaData, index, showArrows, positionHandler, _openAddUserModal, accelerateValue, initialZoom } = props;
  const [hideArrows, setHideArrows] = useState(false);
  const [isPortrait, setIsPortrait] = useState(portrait);
  const schema = schemaData;
  const [dragEnabled, setDragEnabled] = useState(false);
  const measureRef = useRef<MeasurableHandle>(null);
  const positionContext = useContext(UserHierarchyContext);
  const translationX = useSharedValue(0);
  const translationY = useSharedValue(0);
  const absoluteX = useSharedValue(0);
  const absoluteY = useSharedValue(0);
  const arrowPath = useSharedValue('M0,0 L0,0');
  const snapThreshold = 80;
  const breakFreeThreshold = 50;
  const angle = useSharedValue(90);
  const { width, height } = useWindowDimensions();
  const dragArrowRef = useRef(null);
  const ctx = useSharedValue({ startX: 0, startY: 0, startAbsoluteX: 0, startAbsoluteY: 0, isSnapped: false, snappedIndex: -1 });
  const [positions, setPositions] = useState<any[]>([]);
  const positionValues = useSharedValue([]);
  const [dragging, setDragging] = useState(false);
  const [isArrowDragged, setIsArrowDragged] = useState(false);
  const [zoomProps, setZoomProps] = useState(zoomVars);
  const [componentDimensions, setComponentDimensions] = useState({ width: 0, height: 0 });
  const dispatch = useDispatch();
  const [expand, setExpand] = useState(false);
  const [accValue, setAccValue] = useState(accelerateValue);
  const theme = themeSelector();


  const [newActionList, setNewActionList] = useState(flowList);

  useImperativeHandle(ref, () => ({
    setValues(values) {
      if (positions.length < 1) {
        setPositions([values]);
      } else {
        setPositions(prevPositions => {
          const filteredPositions = prevPositions.filter(pos => pos.id !== values.id); // Remove the position with the same id
          return [...filteredPositions, values]; // Append the new values
        });
      }
    },
    setZoomProps: (props: ZoomableViewEvent) => {
      setZoomProps(props);
      setAccValue(props.zoomLevel);
    }
  }));

  const snapValues = positions;

  useLayoutEffect(() => {
    measureRef.current?.measureLayout();
  }, [measureRef])

  const measureView = useCallback((e) => {
    const { x, y, width, height } = e;
    // Adjust for zoom and offset
    setComponentDimensions({ width, height });
    if (x) {
      positionHandler?.({ x: x - (width / 2), y: y + (height), id: schemaData._id });
    }
  }, [measureRef]);

  const handleDrag = useCallback(() => {
    // Call debounce outside of the event handler
    const debouncedMeasure = debounce(() => measureRef.current?.measureLayout(), 20);
    debouncedMeasure(); // Call the debounced function
  }, [measureRef]);


  return useMemo(() => (
    <Measurable commitMeasure={undefined} ref={measureRef} style={{ transform: [{ scale: 0.2 }], left: -65, zIndex: 1000000, flex: 1, borderColor: "rgb(90,192,234)", borderRadius: 20, padding: 20, minWidth: width / 2.41, alignSelf: 'stretch', position: 'absolute' }} onMeasure={(x, y, width, height) => { measureView({ x, y, width, height }) }}>
      <Pressable onPress={() => { setExpand(!expand) }} style={{ position: 'absolute', borderWidth: dragEnabled ? 5 : 0, borderColor: 'white', borderStyle: 'dashed', borderRadius: 10, zIndex: 2, flexDirection: 'column', alignContent: 'center', flex: 1, elevation: 1 }} key={schema._id} >
        <Animatable.View transition={'maxHeight'} style={[styles.centerEverything, { borderRadius: 20, elevation: 1, backgroundColor: 'white', padding: 15, flex: 3, minHeight: schema?.dataSchema?.length > 1 && expand ? schema?.dataSchema?.length * 100 + 100 : 200, alignSelf: 'stretch' }]}>
          <View style={{ flex: 1, alignSelf: 'stretch', overflow: 'hidden', borderRadius: 20, padding: 10, margin: -22, backgroundColor: ' #ffffff66' }}>
            <AchievementBackground style={{ position: 'absolute', overflow: 'hidden', opacity: 1, transform: [{ scale: isPortrait ? 12 : 12 }], minWidth: '100%' }} />
            <View style={{ flex: 10, alignSelf: 'stretch', }}>
              <View style={{ flex: 1, borderTopStartRadius: 20, minHeight: 90, borderTopEndRadius: 20, padding: 20, backgroundColor: '#00000030' }}>
                <SizableText numberOfLines={1} style={{ top: 2, width: 600, minHeight: 60, flex: 3, maxHeight: 60, color: "white", fontSize: 42, paddingTop: 15, fontWeight: 'bold' }}>{parseByDelimiter(toTitleCase(schema?.dataTitle))}</SizableText>
                {
                  schema?.createdAt && !expand &&
                  <SizableText style={{ maxWidth: 600, flex: 5, flexWrap: 'wrap', color: "white", fontStyle: 'italic', fontSize: 20, fontWeight: "bold", top: -10, verticalAlign: "middle", paddingTop: 5 }}>Created: {moment(schema?.createdAt).format("Do MMM YYYY HH:MMa") || 'No date found for schema'}</SizableText>
                }
                {
                  schema?.dataTags?.length > 0 && !expand &&
                  <TagViewer item={schema} tags={schema.dataTags} />
                }
                {
                  schema?.description && !expand &&
                  <SizableText style={{ maxWidth: 600, flex: 5, flexWrap: 'wrap', color: "white", fontStyle: 'italic', fontSize: 24, lineHeight: 32, verticalAlign: "middle", paddingTop: 5 }}>{schema?.description || 'No description found for schema'}</SizableText>
                }
              </View>
              <Separator borderColor={"white"} />
              {
                expand && schema?.dataSchema?.map((item, index) => (
                  <View style={{ maxWidth: '90%', padding: 20, paddingHorizontal: 30, minHeight: 80, borderBottomWidth: schema?.dataSchema?.length > index + 1 ? 0.5 : 0, borderColor: 'white', flex: 1, gap: 10, alignSelf: 'stretch' }} key={schema._id + item.type + index}>
                    <Text adjustsFontSizeToFit numberOfLines={1} style={{ fontSize: 25, paddingTop: 10, color: "white", minHeight: 30, verticalAlign: 'middle' }}>{parseByDelimiter(item.title)}</Text>
                  </View>
                ))
              }
            </View>
          </View>
        </Animatable.View>
        {
          !isPortrait && !hideArrows && !dragEnabled && showArrows &&
          <Pressable style={{ position: 'absolute', alignContent: 'center', backgroundColor: 'rgb(90,192,234)', padding: 10, borderRadius: 30, right: 0, top: 30 }} onPress={() => { setIsPortrait(!isPortrait) }}>
            <FontAwesome5 name="arrow-down" size={24} color="white" style={{ textAlign: 'right' }} />
          </Pressable>

        }
        {
          showArrows && !dragEnabled &&
          <View style={{ minWidth: 100, maxHeight: 100, position: 'relative', overflow: 'visible', alignSelf: 'center', top: 100, left: 30 }}>
            <ActionArrow zoomVars={zoomVars} />
          </View>
        }
      </Pressable>
    </Measurable>
  ), [isPortrait, dragEnabled, hideArrows, schema, schemaData, measureRef, handleDrag, newActionList, isArrowDragged, positionValues, positions, dragArrowRef, dragging, angle, arrowPath, ctx, snapValues, accelerateValue, showArrows, reverse, onSnap, transform, portrait, zoomVars, positionHandler, _openAddUserModal, index, schemaData, ref])
})



export default FlowComponent;
